import {useDebugValue} from 'react';

import {
    useSearchActions,
    useSearchEvents,
    useSearchValues
} from './';

function useSearch(props) {
    const {
        events
    } = useSearchEvents(props);

    const {
        defaultValues,
        initialValues,
        currentValues,
        latestValues,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    } = useSearchValues(props);

    const actions = useSearchActions({
        events,
        defaultValues,
        initialValues,
        currentValues,
        latestValues,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    });

    const result = {
        actions,
        events,
        currentValues,
        latestValues
    };

    useDebugValue(result);

    return result;
}

export {useSearch};
